import React, {useContext} from 'react'

import { Button } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { Language } from '../../Translation'

import { makeStyles } from '@material-ui/core/styles'
import { StoreContext } from '../../context/StoreContext'

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: "#f5f5f5",
        position: "fixed",
        width: "100%",
        bottom: 0,
    },
    quantityButtons: {
        display: "flex",
        justifyContent: "center",
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    addToCartButton: {
        bottom: -15,
        width: "100%",
    }
}));


export default function ModifyItemFooter({ removeQuantity, addQuantity, addItemToCart, quantity, totalAmount }) {

    const classes = useStyles();

    const appContext = useContext(StoreContext)
    const { language } = appContext;

    return (
        <Card className={classes.footer}>
            <CardContent>
                <div className={classes.quantityButtons}>
                    <Button onClick={() => removeQuantity()} variant="outlined" size="large" color="secondary" ><RemoveIcon /></Button>
                    <Avatar >{quantity}</Avatar>
                    <Button onClick={() => addQuantity()} variant="outlined" size="large" color="primary" ><AddIcon /></Button>
                </div>
                <Button className={classes.addToCartButton} onClick={() => addItemToCart()} variant="contained" size="large" color="primary" >
                    {Language.AddToCart[language]} : {totalAmount.toFixed(2)}$
              </Button>
            </CardContent>
        </Card>
    )

}